import CaptionAndAttributionBlock from "../news/caption-and-attribution-block";
import { imageUrlFor } from "../../lib/image-url";

function RichTextGallery({ images, attribution, caption }) {
  let imageRowCount = 2;
  if (images.length % 3 === 0 || images.length > 4) {
    imageRowCount = 3;
  }

  return (
    <div
      className="my-2 md:my-3 orientationLandscape center"
      style={{
        display: "flex",
        flexFlow: "row wrap",
        justifyContent: "center",
      }}
    >
      {images.length > 0 &&
        images.map((image, index) => {
          const orientation =
            image.asset.metadata.dimensions.aspectRatio < 1
              ? "portrait"
              : "landscape";
          const caption = `${
            image.caption !== undefined ? image.caption : ``
          } ${image.attribution ? `Photo by ${image.attribution}.` : ``}`;
          return (
            <div
              className={`gallery-image-wrapper gallery-${
                images.length === 5 && index > 2 ? 2 : imageRowCount
              }-image-wrapper gallery-image-orientation-${orientation}`}
            >
              <img
                src={imageUrlFor(image)
                  .auto("format")
                  .quality(60)
                  .fit("max")
                  .height(800)
                  .url()}
                loading="lazy"
                alt={image.alt}
              />
              {image.asset.metadata.aspectRatio}
            </div>
          );
        })}

      {(caption || attribution) && (
        <div className={`w-full`}>
          <CaptionAndAttributionBlock
            caption={caption}
            attribution={attribution}
            gallery="s"
          />
        </div>
      )}
    </div>
  );
}

export default RichTextGallery;
